import React from 'react';
import './CategoryFilter.css';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="category-filter">
      <div className="category-filter-wrapper">
        {categories.map(category => (
          <button
            key={category.id}
            className={`category-button ${selectedCategory === category.slug ? 'active' : ''}`}
            onClick={() => onCategoryChange(category.slug)}
            style={{
              '--category-color': category.color
            }}
          >
            <span className="category-icon">{category.icon}</span>
            <span className="category-name">{category.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;